import React, { useMemo, useContext } from "react";
import IconFont from "@/components/icon";
import "./index.less";
import classNames from "classnames";
import { duccConfigI18 } from "@/utils/i18n";
import colors from "@/components/styles/colors";
import { connect } from "dva";
import { Tooltip, message, Dropdown } from "antd";
import ChatState from "@/types/chat/State";
import { Employee, Session, SessionType } from "@/types/chat";
import ImService from "@/server/ImService";
import Bus from "@/utils/bus";
import { sessionSetting } from "@/server/im/SessionService";
import { SessionSettingsType } from "@/types/chat/enum";
import { changeEgovUrl, getAIConfigData } from "@/utils/tools";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";

interface IProps {
  toolsItem: Session;
  customAppList: Session[];
  selectedSession: Session;
  currentEmployee: Employee;
  selectedTabList?: any[];
  children?: React.ReactNode;
  isCustomApp?: boolean;
  onAppToggle: Function;
  onShieldChange: Function;
}

function ToolsItem({
  toolsItem,
  currentEmployee,
  children,
  isCustomApp,
  onAppToggle,
  onShieldChange
}: IProps) {
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const handleAdd = async () => {
    const imService = ImService.getInstance();
    const session = await imService.getSingleSession(
      {
        app: toolsItem.uid?.app || "dd.notice",
        userId: toolsItem.uid?.pin,
        teamId: toolsItem.uid?.teamId || "focus.bot"
      } as any,
      {
        ...currentEmployee,
        pin: currentEmployee.userId
      },
      SessionType.NOTICE
    );
    console.log("session=>", session);
    if (session) {
      if (isCustomApp) {
        // delCustomAppConfig({ appKey: item.appKey, appName: item.appName })
        //   .then(async (res) => {
        //     if (res) {
        //       (session as any).isCustomApp = false;
        //       sessionSetting(SessionSettingsType.SHIELD, (session as any).sessionId, false);
        //       sessionSetting(SessionSettingsType.TOP, (session as any).sessionId, false);
        //       Bus.emit("chat:session-update", session);
        //     }
        //   })
        //   .finally(() => {
        //   });
      } else {
        console.log("移入独立消息会话");
        // addCustomAppConfig({
        //   appKey: toolsItem.pin,
        //   appName: toolsItem.name
        // })
        //   .then(async (res) => {
        //     if (res) {
        //       (session as any).isCustomApp = true;
        //       const tabList = [...selectedTabList];
        //       const index = tabList.findIndex((item) => item.pin === toolsItem.pin);
        //       if (index > -1) {
        //         tabList.splice(index, 1);
        //       }
        //       sessionSetting(SessionSettingsType.SHIELD, (session as any).sessionId, false);
        //       sessionSetting(SessionSettingsType.TOP, (session as any).sessionId, false);
        //       Bus.emit("chat:session-update", session);
        //     }
        //   })
        //   .catch((err) => {
        //     console.log("err=>", err);
        //   })
        //   .finally(() => {
        //   });
      }
    }
  };

  const aiConfigName = useMemo(() => {
    const aiUser = getAIConfigData(appRuntimeEnv, "envConfig.aiConfig.aiUser");
    return aiUser?.name;
  }, [appRuntimeEnv]);

  const TooltipTitle = useMemo(() => {
    return isCustomApp ? `聚合到${aiConfigName}通知` : "移入会话通知";
  }, [isCustomApp, aiConfigName]);

  const handleToggleClick = () => {
    const type = isCustomApp ? "delete" : "add";
    onAppToggle(type, toolsItem);
  };

  const handleShieldChange = (value: 0 | 1) => {
    if (typeof toolsItem.settings?.shield === "number" && value === toolsItem.settings?.shield) {
      return;
    }
    console.log("toolsItem=>", toolsItem.settings);
    onShieldChange(value, toolsItem);
  };

  return (
    <div className="tab-tools-item">
      <div className="tools-item-left">
        {children}
        <img src={changeEgovUrl(toolsItem.info?.avatar)} className="tools-avatar" alt="" />
        <span className="tools-name">{toolsItem.info?.name}</span>
      </div>
      <div className="tools-item-right">
        <Dropdown
          overlay={
            <div className="tools-dropdown-content">
              <div
                className={classNames("tools-dropdown-action", {
                  selected: !toolsItem.settings?.shield
                })}
                onClick={() => handleShieldChange(0)}
              >
                <span className="tools-dropdown-action-text">允许通知</span>
                {!toolsItem.settings?.shield && <IconFont type="iconbtn_check" />}
              </div>
              <div
                className={classNames("tools-dropdown-action", {
                  selected: toolsItem.settings?.shield === 1
                })}
                onClick={() => handleShieldChange(1)}
              >
                <span className="tools-dropdown-action-text">免打扰</span>
                {toolsItem.settings?.shield === 1 && <IconFont type="iconbtn_check" />}
              </div>
            </div>
          }
          placement="bottomCenter" /* trigger={['click']} */
        >
          <div className="tools-dropdown-text">
            <span>{toolsItem.settings?.shield === 1 ? "免打扰" : "允许通知"}</span>
            <IconFont
              type="iconapp_ic_arrow_right"
              style={{ color: "#8F959E", fontSize: "11px" }}
            />
          </div>
        </Dropdown>
        <div className="tools-line" />
        <div className="tools-btns">
          <Tooltip placement="top" title={TooltipTitle}>
            <div className="tools-toggle" onClick={handleToggleClick}>
              {isCustomApp ? (
                <IconFont type="iconic_pc_juhe" className="tools-toggle-icon" />
              ) : (
                <IconFont type="iconic_pc_yiruhuihua" className="tools-toggle-icon" />
              )}
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  const { customAppList, selectedSession, currentEmployee } = chat as ChatState;
  return {
    customAppList,
    selectedSession,
    currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateCustomAppList: (payload: any) => {
      dispatch({ type: "chat/updateCustomAppList", payload });
    },
    async updateFilterTabList(data: { filterTabList: any[] }) {
      await dispatch({ type: "chat/updateFilterTabList", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolsItem);
